import api, { unwrap } from './client';
import { partage } from './partage';

// opts.flatForecast=true → mois > clôture reportés à plat (Bilan prévisionnel).
// opts.through → arrêté d'affichage : la vue se borne à ce mois (≤ clôture).
// Point de départ du plan de liquidité (2026-09-28) : trésorerie de départ et
// postes ouverts, réels ou tapés, avec leur profil de règlement.
export const getOpeningItems = (tenantId, year) =>
  unwrap(api.get(`/financials/bs/${tenantId}/opening-items`, { params: { year } }));

export const getBsView      = (tenantId, year, opts = {}) => partage(
  `bs:${tenantId}:${year}:${JSON.stringify(opts)}`,
  () => unwrap(api.get(`/financials/bs/${tenantId}`, { params: { year,
    ...(opts.flatForecast ? { flat_forecast: true } : {}),
    ...(opts.version ? { version: opts.version } : {}),
    ...(opts.through ? { through: opts.through } : {}),
    ...(opts.loaded ? { loaded: true } : {}) } })));
export const listBsAccounts  = (tenantId)       => unwrap(api.get(`/financials/bs/${tenantId}/accounts`));
export const createBsAccount = (tenantId, account_number, account_desc) =>
  unwrap(api.post(`/financials/bs/${tenantId}/accounts`, { account_number, account_desc }));
export const deleteBsAccounts = (tenantId, account_numbers) =>
  unwrap(api.post(`/financials/bs/${tenantId}/accounts/delete`, { account_numbers }));
export const renameBsSection = (tenantId, code, label) => unwrap(api.patch(`/financials/bs/${tenantId}/sections/${code}`, { label }));

export const patchBsAccountLine = (tenantId, account, reporting_line) =>
  unwrap(api.patch(`/financials/bs/${tenantId}/accounts/${encodeURIComponent(account)}`, { reporting_line }));

export const setBsMonthly = (tenantId, payload) =>
  unwrap(api.patch(`/financials/bs/${tenantId}/monthly`, payload));

export const setBsLineForecast = (tenantId, payload) =>
  unwrap(api.patch(`/financials/bs/${tenantId}/forecast`, payload));

// Note libre sur une cellule (compte × mois) : { year, account_number, month, note }
export const setBsNote = (tenantId, payload) =>
  unwrap(api.patch(`/financials/bs/${tenantId}/notes`, payload));

export const listBsLines   = (tenantId)                 => unwrap(api.get(`/financials/bs/${tenantId}/lines`));
export const createBsLine  = (tenantId, section, label) => unwrap(api.post(`/financials/bs/${tenantId}/lines`, { section, label }));
export const updateBsLine  = (tenantId, lineId, patch)  => unwrap(api.patch(`/financials/bs/${tenantId}/lines/${lineId}`, patch));
export const deleteBsLine  = (tenantId, lineId)         => unwrap(api.delete(`/financials/bs/${tenantId}/lines/${lineId}`));
export const reorderBsLines = (tenantId, ids)           => unwrap(api.post(`/financials/bs/${tenantId}/lines/reorder`, { ids }));

// Classement Cash Flow : affecte (ou retire si null) la catégorie d'une ligne de bilan.
export const setBsCfCategory = (tenantId, lineId, cf_category) =>
  unwrap(api.patch(`/financials/bs/${tenantId}/lines/${lineId}/cf-category`, { cf_category }));

export const importBsExcel = (tenantId, file, year) => {
  const fd = new FormData();
  fd.append('file', file);
  return unwrap(api.post(`/financials/bs/${tenantId}/import`, fd, {
    params: { year },
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
};
